"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTimeout;

var _react = require("react");

// See www.joshwcomeau.com/snippets/react-hooks/use-timeout/
function useTimeout(callback, delay) {
  var timeoutRef = (0, _react.useRef)(null);
  var savedCallback = (0, _react.useRef)(callback);
  (0, _react.useEffect)(function () {
    savedCallback.current = callback;
  }, [callback]);
  (0, _react.useEffect)(function () {
    var tick = function tick() {
      return savedCallback.current();
    };

    if (typeof delay === 'number') {
      timeoutRef.current = window.setTimeout(tick, delay);
      return function () {
        return window.clearTimeout(timeoutRef.current);
      };
    }
  }, [delay]);
  return timeoutRef;
}